import { extendTheme } from '@chakra-ui/react';
import { FONT_FAMILY } from '@/constants/default-props';
import { BG_COLOR, TEXT_COLOR } from '@/constants/colors';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body_lv2: FONT_FAMILY.body_lv2,
    body: FONT_FAMILY.body,
    // hardcoded font family for qrcode purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '48px',
    subHeading: '38px',
    body: '16px',
    body_lv2: '14px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
    body_lv2: 800,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
      },
    },
  },
  colors: {
    bgPrimary: '#f9f1e6',
    bgSecondary: '#550001',
    bgAlternative: '#b8a487',
    mainColorText: '#1a1b1d',
    secondaryColorText: '#fef8f3',
    alternativeColorText: '#830000',

    transparent: 'transparent',
  },
  breakpoints: {
    base: '0px',
    xs: '321px',
    sm: '414px',
    md: '768px',
    lg: '960px',
    xl: '1200px',
    '2xl': '1536px',
  },
};

export default extendTheme(theme);
